<template>
    <div v-if="loggedIn">
        <div class="text-center text-xs">
            <PhoneSVG></PhoneSVG>
            <span class="underline">{{getPhoneNumber}}</span>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import PhoneSVG from "@/components/shared/svgs/PhoneSVG";

    export default {
        name: "PersonalContact",
        components: { PhoneSVG },
        computed: {
            ...mapGetters('auth', {
                'loggedIn': 'loggedIn'
            }),
            ...mapGetters('dlGroupConfig', [
                'getPhoneNumber',
            ]),
            ...mapState('auth', {
                'user': 'user'
            })
        }
    }
</script>

<style scoped>

</style>